import styled, { css } from 'styled-components';
import { H3, Overline } from 'components/Typography';
import addAlpha from 'utils/addAlpha';
import DefaultDatesSelector from 'components/Form/WeekRangePicker';
import DefaultRow from './Row';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  width: 100%;
  height: auto;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow:
    0rem 0.5rem 1rem rgba(35, 35, 35, 0.02),
    0rem 0.5rem 2rem rgba(35, 35, 35, 0.02);
  border-radius: 1.5rem;
  margin-bottom: 8rem;
`;

// TODO: TFR-45:Title make unique name or do not export
export const Title = styled(H3)`
  margin-bottom: 1rem;
`;

// TODO: TFR-45:Header make unique name or do not export
export const Header = styled.header`
  display: grid;
  grid-template-columns: 0.8fr 1fr 11rem 1fr 15rem 20rem;
  height: 3rem;
  padding: 1.375rem 2rem 1.375rem 0;
`;

// TODO: TFR-44 move to container group
export const Row = styled(DefaultRow)`
  display: grid;
  grid-template-columns: 0.8fr 1fr 11rem 1fr 15rem 20rem;
  height: auto;
  padding: 1.5rem 2rem 1.5rem 0;
  align-items: center;
`;

// TODO: TFR-44 move to typography group
export const Caption = styled(Overline)<{ align?: 'right' | 'left' }>`
  width: auto;
  text-align: right;
  letter-spacing: 0.1em;
  font-weight: 600;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  margin-left: 3.125rem;
  ${({ align }) =>
    align === 'left' &&
    css`
      text-align: left;
    `}
`;

export const DatesSelector = styled(DefaultDatesSelector)``;

export const PickerContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const DateCaption = styled(H3)`
  margin-right: 1.5rem;
`;
